var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import HomeSmileSvg from './home-smile.icon.svg';
export const HomeSmileIcon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, SvgComponent: HomeSmileSvg }));
_react_refresh_temp_1 = HomeSmileIcon;
$RefreshReg$(_react_refresh_temp_1, "HomeSmileIcon");
